import React from 'react';
import { GraduationCapIcon, HandIcon, SchoolIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [HandIcon, GraduationCapIcon, SchoolIcon];
const tints = ['#F1D8C9', '#D9C3E9', '#D6DCF4'];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-47" data-mp="1t8qvunmllrdf">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="2858b3pxwrq59">
        <SectionHeading id="audience-heading" title={<>
              Für Nageldesign-Profis, die <Accent data-id="element-50" data-mp="2gzcvbqije3bt">ihr Wissen weitergeben möchten.</Accent>
            </>} data-id="element-49" data-mp="237q0zw85n4vo" />

        <ul className="mt-12 grid gap-4 md:grid-cols-3" role="list" data-id="element-51" data-mp="2cwzt3c300njs">
          {audience.map((item, index) => {
          const Icon = icons[index];
          return <li key={item.title} className="flex flex-col items-center rounded-[20px] bg-white px-6 py-8 text-center" data-id="element-52" data-mp="2ly7ptppv9gbr" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: tints[index]
            }} data-id="element-53" data-mp="1sc43se2kltnu">
                  <Icon className="h-5 w-5 text-brand-forest" strokeWidth={1.5} aria-hidden="true" data-id="element-54" data-mp="22a092p8ttue1" />
                </span>
                <h3 className="mt-4 font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-55" data-mp="26cespbkbky6d">
                  {item.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-56" data-mp="2g9jhzk9gp9re">{item.text}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}